import * as React from "react"

import { cn } from "@/lib/utils"

const Container = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn("shadow-elevation-card-rest bg-ui-bg-base w-full rounded-lg px-6 py-4", className)}
      {...props}
    />
  )
)
Container.displayName = "Container"

export { Container }
